import { combineEpics, ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { asyncFinish } from '../../../common/+store/async';
import { commonApiCallFragment } from '../../../common/+store/utils/utils.api';
import { GET_CLASSLINK_SETTINGS } from './Integrations.actions';
import { getClasslinkSettings } from './Integrations.api';

const getClasslinkSettingsEpic = (action$) =>
  action$.pipe(
    ofType(GET_CLASSLINK_SETTINGS),
    switchMap((action) =>
      from(getClasslinkSettings()).pipe(commonApiCallFragment(action$, action, 'Getting ClassLink settings'))
    ),
    switchMap((results) => {
      if (results.success) {
        return of(asyncFinish(GET_CLASSLINK_SETTINGS, results.response.data));
      }
      if (results.actions) return of(...results.actions);
      return of(results.action);
    })
  );

const epics = combineEpics(getClasslinkSettingsEpic);

export default epics;
